<template>
	<div tabindex="0" @keyup.esc="closeAdd()" class="hide-outline">
		<TopPanel
			:units="['rondplanering', 'Rondplaneringar', 'Ny rondplanering']"
			:pagination="pagination"
			:showCustomer="true"
			:orderBys="orderBys"
			:orderBy="searchParams.orderBy"
			:hide-add="!$isAllowedTo('roundplannings_edit')"
			@toggleAdd="navigate"
			@search="search"
			@orderBy="orderBy"
		/>
		<main class="main-view columns">
			<RoundPlanningList
				:roundPlannings="roundPlannings"
				@delete="askToDelete"
				@edit="edit"
				@search="getRoundPlannings"
			/>
		</main>
		<DeleteModal
			v-if="showDelete"
			@confirm="deleteSelected"
			@cancel="cancelDelete"
			:message="deleteMessage"
		/>
	</div>
</template>

<script>
import { mapState, mapGetters, mapActions, mapMutations } from 'vuex';
import RoundPlanningList from './components/RoundPlanningList';
import DeleteModal from '@/components/DeleteModal';
import TopPanel from '@/components/TopPanel';

export default {
	components: {
		RoundPlanningList,
		DeleteModal,
		TopPanel
	},

	data() {
		return {
			showDelete: false,
			selectedRoundPlanning: {},
			orderBys: [
				{ name: 'Namn', value: 'Name' },
				{ name: 'Skapad', value: 'Created' }
			]
		};
	},

	computed: {
		...mapState('roundPlanningStore', ['searchParams']),
		...mapGetters('roundPlanningStore', ['roundPlannings', 'pagination']),
		...mapGetters('user', ['getActiveCustomer']),

		deleteMessage() {
			return this.selectedRoundPlanning.name
				? `Är du säker på att du vill ta bort rondplanering vid namn '${this.selectedRoundPlanning.name}', och relaterad historik, brister och filer?`
				: '';
		}
	},

	watch: {
		'getActiveCustomer.id'() {
			this.SET_ROUNDPLANNINGS([]);
			this.getRoundPlannings();
		}
	},

	created() {
		this.searchParams.buildingId = null;
		this.SET_ROUNDPLANNINGS([]);
		this.getRoundPlannings();
	},

	methods: {
		...mapActions('roundPlanningStore', ['getRoundPlannings', 'deleteRoundPlanning']),
		...mapMutations('roundPlanningStore', ['SET_ROUNDPLANNINGS']),

		navigate() {
			let id = this.selectedRoundPlanning.id || 0;
			this.$router.push({
				name: 'RoundPlanningDetailView',
				params: {
					roundPlanningId: id
				}
			});
		},

		edit(roundPlanning) {
			Object.assign(this.selectedRoundPlanning, roundPlanning);
			this.navigate();
		},

		askToDelete(roundPlanning) {
			this.showAdd = false;
			Object.assign(this.selectedRoundPlanning, roundPlanning);
			this.showDelete = true;
		},

		cancelDelete() {
			this.showDelete = false;
			this.selectedRoundPlanning = {};
		},

		deleteSelected() {
			this.deleteRoundPlanning(this.selectedRoundPlanning).then(() => {
				this.showDelete = false;
				this.selectedRoundPlanning = {};
			});
		},

		search(searchValue) {
			this.searchParams.search = searchValue;
			this.getRoundPlannings();
		},

		orderBy(orderBy) {
			this.searchParams.orderBy = orderBy;
			this.getRoundPlannings();
		}
	}
};
</script>
<style lang="scss">
.spinner {
  position: absolute;
  top: 200px;
  left: 50%;
}
</style>
